import { render } from "./CompletedProjects.vue?vue&type=template&id=02d4ecbc&scoped=true"
import script from "./CompletedProjects.vue?vue&type=script&lang=js"
export * from "./CompletedProjects.vue?vue&type=script&lang=js"

import "./CompletedProjects.vue?vue&type=style&index=0&id=02d4ecbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d4ecbc"]])

export default __exports__